import { Box, rem, Tabs, Text, Textarea } from "@mantine/core";
import type { ReactNode } from "react";
import { PromptTemplateMarkdownPreview } from "src/components/promptTemplateMarkdownPreview";

type PromptTemplateContentFieldProps = {
    value: string;
    onChange: (value: string) => void;
    error?: ReactNode;
    required?: boolean;
};

export function PromptTemplateContentField({
    value,
    onChange,
    error,
    required,
}: PromptTemplateContentFieldProps) {
    return (
        <Box>
            <Text size="sm" fw={500} mb={4}>
                Content
                {required ? (
                    <Text component="span" c="red">
                        {" "}
                        *
                    </Text>
                ) : null}
            </Text>
            <Text size="xs" c="dimmed" mb="xs">
                Markdown formatting is preserved when saved and inserted into chat.
            </Text>
            <Tabs defaultValue="edit">
                <Tabs.List>
                    <Tabs.Tab value="edit">Markdown</Tabs.Tab>
                    <Tabs.Tab value="preview">Preview</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value="edit" pt="xs">
                    <Textarea
                        required={required}
                        aria-label="Template content"
                        placeholder="Write your prompt in markdown…"
                        minRows={10}
                        autosize
                        maxRows={24}
                        value={value}
                        error={error}
                        onChange={(event) => onChange(event.currentTarget.value)}
                        styles={{
                            input: {
                                fontFamily: "var(--mantine-font-family-monospace)",
                                whiteSpace: "pre-wrap",
                            },
                        }}
                    />
                </Tabs.Panel>
                <Tabs.Panel value="preview" pt="xs">
                    <Box
                        style={{
                            border: "1px solid var(--mantine-color-gray-3)",
                            borderRadius: "var(--mantine-radius-sm)",
                            minHeight: rem(200),
                        }}
                    >
                        {value ? (
                            <PromptTemplateMarkdownPreview content={value} />
                        ) : (
                            <Text c="dimmed" size="sm" p="sm">
                                Nothing to preview
                            </Text>
                        )}
                    </Box>
                </Tabs.Panel>
            </Tabs>
        </Box>
    );
}
